import { render } from "./SysWechatDialog.vue?vue&type=template&id=88cf557a&scoped=true"
import script from "./SysWechatDialog.vue?vue&type=script&lang=js"
export * from "./SysWechatDialog.vue?vue&type=script&lang=js"

import "./SysWechatDialog.vue?vue&type=style&index=0&id=88cf557a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cf557a"]])

export default __exports__